import { useHubFavicon } from '../../hooks/useHubFavicon'

/** Applies VIVA HUB favicon and document title on hub and scheduler routes. */
export default function HubFavicon () {
  useHubFavicon()
  return null
}
